import React, { Fragment } from 'react'
import Header from 'src/Components/Header'
import Logo from 'src/Components/Logo'
import Notifications from 'src/App/Layout/Header/Notifications'
import AgentDropdown from 'src/App/Layout/Header/AgentDropdown'
import Navigation, {
  SubNav
} from 'src/features/homeowners/Components/Navigation'

import styles from './HomeownerHeader.module.scss'

const HomeownerHeader = () => (
  <Fragment>
    <Header>
      <Header.Content>
        <Logo />
        <Navigation />
        <Header.Actions>
          <Notifications />
          <AgentDropdown className={styles.agentDropdown} />
        </Header.Actions>
      </Header.Content>
    </Header>
    <SubNav />
  </Fragment>
)

export default HomeownerHeader
